import { Injectable } from '@angular/core';
import { FirestoreSubCollectionRepository } from '@core/services';

export interface ClientIntakeFormContextPathParams {
	businessId: string;
	matterId: string;
	clientIntakeFormId: string;
}

type ContextData = Record<string, unknown>;

@Injectable({
	providedIn: 'root',
})
export class ClientIntakeFormContextSubCollectionRepo extends FirestoreSubCollectionRepository<
	ContextData,
	ClientIntakeFormContextPathParams
> {
	protected getCollectionPath(
		params: ClientIntakeFormContextPathParams,
	): string {
		return `businesses/${params.businessId}/matters/${params.matterId}/clientIntakeForms/${params.clientIntakeFormId}/intakeFormContext`;
	}
}
